import { Divider, Spin, Switch } from "antd";
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from "../../../../util/store/store";
import { routeActions } from "../../reducer";
import Empty from "./Empty";
import RouteItem from "./RouteItem";
import styles from './style.module.scss';

const SwitchSeaWay = () => {
    const isShowAll = useSelector(state => state.route.isShowAll);
    const dispatch = useDispatch();

    const handleChange = () => {
        dispatch(routeActions.changeShowAll());
    }

    return <div className="flex items-center gap-2">
        <Divider orientation="vertical" className="h-[20px] mr-0 border-[var(--colorMain)]" />
        <span>Show all routes</span>
        <Switch checked={isShowAll} onChange={handleChange} />
    </div>
}

interface IProps {
}

const RouteTable: React.FC<IProps> = () => {
    const params = useSelector(state => state.route.params)
    const loading = useSelector(state => state.route.loading.routes)
    const routes = useSelector(state => state.route.routes) || [];

    const { source, destination } = params;

    if (!source || !destination) return null;

    return <Spin spinning={loading}>
        <div className="flex items-center justify-between mt-5 mb-3 text-[15px] px-[30px]">
            <div className="font-[600]">Route list</div>
            <SwitchSeaWay />
        </div>
        <div className={styles['container-routes']}>
            {routes.length === 0 && !loading && <Empty />}
            {routes.map((item, index) => <RouteItem key={item.id} data={item} index={index} />)}
        </div>
    </Spin>;
};

export default RouteTable;